import isHotkey from 'is-hotkey';

import { type Editor } from '@@editor/helpers';
import { type HandleHotkey } from '@@editor/helpers/Editor';

const handleHotkey = (
    editor: Editor,
    handlersConfig: [string, (props: Editor) => void][],
    options = { breakPluginChain: true },
): HandleHotkey => {
    const { handleHotkey } = editor;
    const { breakPluginChain } = options;

    return (e) => {
        const handlerConfig = handlersConfig.find(([hotkey]) => isHotkey(hotkey, e.nativeEvent));

        if (handlerConfig) {
            e.preventDefault();

            const [, fn] = handlerConfig;

            fn(editor);

            if (breakPluginChain) {
                return;
            }
        }

        handleHotkey(e);
    };
};

export default handleHotkey;
